// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","socialIcons":"Footer_socialIcons__RhpXs","footerText":"Footer_footerText__y-wf5"};